import { Get, Post, PostForm } from "@/request/http";

// 获取微信登录二维码
export const LoginIn = () => Post("/workai/weixin/createewm");
// 请求微信登录状态
export const getLoginStatus = (data: any) => PostForm("/workai/login/status", data);